import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function CollapseContent({ open, children, className, onOpen, allowOverflow }) {
    const [isAnimating, setIsAnimating] = useState(false);

    return (
        <AnimatePresence initial={false}>
            {open && (
                <motion.div
                    key="content"
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { height: 'auto', opacity: 1 },
                        collapsed: { height: 0, opacity: 0 },
                    }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                    onAnimationStart={() => setIsAnimating(true)}
                    onAnimationComplete={() => {
                        setIsAnimating(false);
                        if (onOpen && open) {
                            onOpen();
                        }
                    }}
                    className={cn('min-w-0', className)}
                    style={{ overflow: isAnimating && !allowOverflow ? 'hidden' : undefined }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
}

CollapseContent.propTypes = {
    open: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onOpen: PropTypes.func,
    allowOverflow: PropTypes.bool,
};
